import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';
import { listenForLaunchedFiles } from './state/launch.ts';
import './styles/global.css';
import './styles/editor.css';

// Before the first render, so a project file the app was launched with is picked up right away.
listenForLaunchedFiles();

// The service worker lets the installed app start offline. Production only: in development it
// would serve stale modules.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err: unknown) => {
      console.warn('Service worker registration failed', err);
    });
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
